var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { EntityValuePill } from './entity-value-pill';
var cls = classNames('entity-value-pill-list');
import { get } from 'lodash';
export var EntityValuePillListDefaultProps = {
  items: [],
  showLabel: false,
  variant: 'smallName',
  showTitleLabel: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 8px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 8px;\n  "])))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-right: ", ";\n   \n  "], ["\n    padding-right: ", ";\n   \n  "])), theme.UNIT(4))
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled.div.attrs(cls.attr('items'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled(EntityValuePill)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Label: styled(CellLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var EntityValuePillList = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items,
    variant = props.variant,
    showLabel = props.showLabel,
    showTitleLabel = props.showTitleLabel;
  var schema = get(items, '[0]._schema', {});
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, showTitleLabel && schema.pluralLabel && React.createElement(My.Label, null, schema.pluralLabel, ":"), React.createElement(My.Items, null, items.map(function (entity) {
    return React.createElement(My.Item, {
      showLabel: showLabel,
      entity: entity,
      variant: variant,
      key: entity.id
    });
  })), children);
};
EntityValuePillList.defaultProps = EntityValuePillListDefaultProps;
EntityValuePillList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;